/**
 * PidEditor — Wave CH.1 · Interactive P&ID Editor
 * Re-uses BaseEngineeringEditor with docKind="pid".
 */
import React from "react";
import { BaseEngineeringEditor } from "./PfdEditor";

export default function PidEditor(props) {
   return <BaseEngineeringEditor {...props} docKind="pid"/>;
}
